
import { gql } from '@apollo/client/core';

export const GET_USER_DATA = gql`
  query GetUser($id: ID!) {
    data {
      id
      attributes{
      email
      username
      role {
        name
      }
    }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUserByDocumentId(
    $documentId: ID!
    $data: UpdateUserByDocumentIdInput!
  ) {
    updateUserByDocumentId(documentId: $documentId, data: $data) {
      data {
        documentId
        username
        email
        fullname
	currency
        confirmed
        blocked
        admin
        role {
          documentId
          name
          type
        }
      }
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($data: UsersPermissionsUserInput!) {
    createUsersPermissionsUser(data: $data) {
      data {
        documentId
        username
        email
        fullname
        confirmed
        blocked
	rateperhour
	rateperday
        admin
        role {
          documentId
          name
          type
        }
      }
    }
  }
`;

export const UPDATE_USEROLD = gql`
  mutation UpdateUser($id: ID!, $data: UsersPermissionsUserInput!) {
    updateUsersPermissionsUser(documentId: $id, data: $data) {
      data {
        documentId
        username
        email
        fullname
        confirmed
        blocked
        admin
        role {
          documentId
          name
          type
        }
      }
    }
  }
`;

export const GET_ALL_USERS = gql`
  query GetAllUsers {
    usersPermissionsUsers {
      data {
        documentId
        id
        username
        email
        confirmed
	admin
        blocked
        role {
          documentId
          name
        }
        carehomes {
          documentId
          name
        }
      }
    }
  }
`;

export const GET_USERS_BY_ADMIN = gql`
  query GetUsersByAdmin($sort: [String], $admin: String) {
    usersPermissionsUsers(
    sort: $sort 
    filters: {
    admin: { eq: $admin }
    }
    ) {
      documentId
      username
      email
      fullname
      confirmed
      blocked
      admin
      rateperhour
      rateperday
      role {
        documentId
        name
        type
      }
    }
  }
`;

export const GET_ROLES = gql`
  query GetRoles {
    usersPermissionsRoles {
      documentId
      name
      type
    }
  }
`;

export const GET_FULLNAME_BY_ID = gql`
      query GetFullnameById($id: ID!) {
        resident(id: $id) {
          data{
          id
          attributes{
            firstname
            lastname           
          }   
        }       
        }
      }
    `;

export const GET_PRIVACYPOLICIES = gql`
  query {
    privacypolicies {
    documentId
      title
      effectivedate
      privacypolicy{
        header
        main
      }
    }
  }
`;

export const GET_TERMSOFUSE = gql`
  query {
    termsofuses {
       documentId
      title
      effectivedate
      termsofuse{
        header
        main
      }
    }
  }
`;


export const GET_RESIDENTS = gql`
query{
    residents {
      data{
        id
        attributes{
            firstname
            lastname
            nickname
            dob
            gender
            address
            race
            dnr
            dnrtype
            specialinstruction
            pressuresore
            admissiondate
            medcart
            roomnumber
            allergy
            diagnosis
            diet
            phone
            email
            hiv
            locationfrom
            mothername
            fathername
            city
            state
            countryofbirth
            religion
            spousename
            personpayingforcare
            personpayingforcarephone
            occupation
            idnumber
            military
            hospital
            hcs
            ssn
            maritalstatus
            referredby
            livingwill
            glasses
            denture
            codestatus
            mobilitydevice
            status          
        }
      }
    }
  }
`;

export const UPDATE_RESIDENT = gql`
  mutation UpdateResident($id: ID!, $data: ResidentInput!) {
    updateResident(id: $id, data: $data) {
      data {
        id
        attributes {
          firstname
          lastname
          nickname
          dob
          gender
          address
          race
          dnr
          dnrtype
          specialinstruction
          pressuresore
          admissiondate
          medcart
          roomnumber
          allergy
          diagnosis
          diet
          phone
          email
          hiv
          locationfrom
          mothername
          fathername
          city
          state
          countryofbirth
          religion
          spousename
          personpayingforcare
          personpayingforcarephone
          occupation
          idnumber
          military
          hospital
          hcs
          ssn
          maritalstatus
          referredby
          livingwill
          glasses
          denture
          codestatus
          mobilitydevice
          status
        }
      }
    }
  }
`;


export const CREATE_RESIDENT = gql`
  mutation CreateResident($data: ResidentInput!) {
    createResident(data: $data) { 
        data{     
      attributes {
        firstname
          lastname
          nickname
          dob
          gender
          address
          race
          dnr
          dnrtype
          specialinstruction
          pressuresore
          admissiondate
          medcart
          roomnumber
          allergy
          diagnosis
          diet
          phone
          email
          hiv
          locationfrom
          mothername
          fathername
          city
          state
          countryofbirth
          religion
          spousename
          personpayingforcare
          personpayingforcarephone
          occupation
          idnumber
          military
          hospital
          hcs
          ssn
          maritalstatus
          referredby
          livingwill
          glasses
          denture
          codestatus
          mobilitydevice
          status
          publishedAt
      }
    }
    }
  }
`;

export const GET_DOCUMENTS_BY_RESIDENT = gql`
query GetDocumentsByResident($residentId: ID!) {
  residentdocuments(filters: { resident: { id: { eq: $residentId } } }) {
    data {
      id
      attributes {
        documentname
        description
        documenttype
        expiredate   
        resident {
          data {
            id
            attributes {
              firstname
              lastname
            }
          }
        }
      }
    }
  }
}
`;

export const GET_DOCUMENTS = gql`
query{
    residentdocuments{
      data{
        id
        attributes{
            documentname
            description
            documenttype
            expiredate                             
        }
      }
    }
  }
`;

export const UPDATE_DOCUMENT = gql`
  mutation UpdateResidentdocument($id: ID!, $data: ResidentdocumentInput!) {
    updateResidentdocument(id: $id, data: $data) {
      data {
        id
        attributes {
            documentname
            description
            documenttype
            expiredate
        }
      }
    }
  }
`;

export const CREATE_DOCUMENT = gql`
  mutation Createresidentdocument($data: ResidentdocumentInput!) {
    createResidentdocument(data: $data) { 
        data{     
      attributes {
        documentname
            description
            documenttype
            expiredate
          publishedAt
      }
    }
    }
  }
`;

export const GET_CONTACTS_BY_RESIDENT = gql`
query GetContactsByResident($residentId: ID!) {
  residentcontacts(filters: { resident: { id: { eq: $residentId } } }) {
    data {
      id
      attributes {
        firstname
        lastname
        contacttype
        duties
        address
        city
        state
        zipcode
        notes
        homephone
        businessphone
        mobilephone  
        email   
        resident {
          data {
            id
            attributes {
              firstname
              lastname
            }
          }
        }
      }
    }
  }
}
`;


export const GET_CONTACTS = gql`
query{
    residentcontacts{
      data{
        id
        attributes{
            firstname
            lastname
            contacttype
            duties
            address
            city
            state
            zipcode
            notes
            homephone
            businessphone
            mobilephone  
            email                           
        }
      }
    }
  }
`;

export const UPDATE_CONTACT = gql`
  mutation UpdateResidentcontact($id: ID!, $data: ResidentcontactInput!) {
    updateResidentcontact(id: $id, data: $data) {
      data {
        id
        attributes {
          firstname
          lastname
          contacttype
          duties
          address
          city
          state
          zipcode
          notes
          homephone
          businessphone
          mobilephone  
          email
        }
      }
    }
  }
`;

export const CREATE_CONTACT = gql`
  mutation Createresidentcontact($data: ResidentcontactInput!) {
    createResidentcontact(data: $data) { 
        data{     
      attributes {
        firstname
         lastname
          contacttype
          duties
          address
          city
          state
          zipcode
          notes
          homephone
          businessphone
          mobilephone  
          email
          publishedAt
      }
    }
    }
  }
`;

export const GET_INSURANCES_BY_RESIDENT = gql`
query GetInsurancesByResident($residentId: ID!) {
  residentinsurances(filters: { resident: { id: { eq: $residentId } } }) {
    data {
      id
      attributes {
        providername
        groupno
        insuranceidno
        insurancetype
        resident {
          data {
            id
            attributes {
              firstname
              lastname
            }
          }
        }
      }
    }
  }
}
`;


export const GET_INSURANCES = gql`
query{
    residentinsurances{
      data{
        id
        attributes{
            providername
            groupno
            insuranceidno
            insurancetype                   
        }
      }
    }
  }
`;

export const UPDATE_INSURANCE = gql`
  mutation UpdateResidentinsurance($id: ID!, $data: ResidentinsuranceInput!) {
    updateResidentinsurance(id: $id, data: $data) {
      data {
        id
        attributes {
          providername
          groupno
          insuranceidno
          insurancetype  
        }
      }
    }
  }
`;

export const CREATE_INSURANCE = gql`
  mutation Createresidentinsurance($data: ResidentinsuranceInput!) {
    createResidentinsurance(data: $data) { 
        data{     
      attributes {
        providername
        groupno
        insuranceidno
        insurancetype
        publishedAt
      }
    }
    }
  }
`;

export const GET_PROVIDERS_BY_RESIDENT = gql`
query GetProvidersByResident($residentId: ID!) {
  residentproviders(filters: { resident: { id: { eq: $residentId } } }) {
    data {
      id
      attributes {
        providername
            phone
            email
            address
            providertype  
        resident {
          data {
            id
            attributes {
              firstname
              lastname
            }
          }
        }
      }
    }
  }
}
`;


export const GET_PROVIDERS = gql`
query{
    residentproviders{
      data{
        id
        attributes{
            providername
            phone
            email
            address
            providertype                   
        }
      }
    }
  }
`;

export const UPDATE_PROVIDER = gql`
  mutation UpdateResidentprovider($id: ID!, $data: ResidentproviderInput!) {
    updateResidentprovider(id: $id, data: $data) {
      data {
        id
        attributes {
          providername
          phone
          email
          address
          providertype   
        }
      }
    }
  }
`;

export const CREATE_PROVIDER = gql`
  mutation Createresidentprovider($data: ResidentproviderInput!) {
    createResidentprovider(data: $data) { 
        data{     
      attributes {
        providername
        phone
        email
        address
        providertype 
        publishedAt
      }
    }
    }
  }
`;

export const GET_VITALS_BY_RESIDENT = gql`
  query GetVitalsByResident($residentId: ID!) {
    residentvitals(filters: { resident: { id: { eq: $residentId } } }) {
      data {
        id
        attributes {
          vitaltype
          value
          note
          daterecorded
          startdate
          enddate
          sizetype
          witnesstype
          activitytype
          continencetype
          consistencytype 
          resident {
            data {
              id
              attributes {
                firstname
                lastname
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_VITALS = gql`
query{
    residentvitals{
      data{
        id
        attributes{            
          vitaltype
          value
          note
          daterecorded
          startdate
          enddate
          sizetype
          witnesstype
          activitytype
          continencetype
          consistencytype
        }
      }
    }
  }
`;
export const CREATE_VITAL = gql`
  mutation Createresidentvital($data: ResidentvitalInput!) {
    createResidentvital(data: $data) { 
        data{     
      attributes {
        vitaltype
          value
          note
          daterecorded
          startdate
          enddate
          sizetype
          witnesstype
          activitytype
          continencetype
          consistencytype
        publishedAt
      }
    }
    }
  }
`;

export const UPDATE_VITAL = gql`
  mutation UpdateResidentvital($id: ID!, $data: ResidentvitalInput!) {
    updateResidentvital(id: $id, data: $data) {
      data {
        id
        attributes {
          vitaltype
          value
          note
          daterecorded
          startdate
          enddate
          sizetype
          witnesstype
          activitytype
          continencetype
          consistencytype
        }
      }
    }
  }
`;

export const GET_CHARTINGS = gql`
query{
    residentchartings{
      data{
        id
        attributes{
            daterecordedfrom
            daterecordedto
            notetype
            chartingnote              
	    taker
        }          
      }
    }
  }
`;

export const GET_CHARTINGS_BY_RESIDENT = gql`
  query GetChartingsByResident(
    $residentId: ID!,
    $pagination: PaginationArg,
    $startDate: DateTime,
    $sort: [String],
    $endDate: DateTime
  ) {
    residentchartings(
      filters: {
        resident: { id: { eq: $residentId } }
        daterecordedfrom: {
          gte: $startDate
          lte: $endDate
        }
      }
      sort: $sort      
      pagination: $pagination
    ) {
      data {
        id
        attributes {
          daterecordedfrom
          daterecordedto
          notetype
          chartingnote  
          taker
          resident {
            data {
              id
              attributes {
                firstname
                lastname
              }
            }
          }
        }
      }
    }
  }
`;



export const CREATE_CHARTING = gql`
  mutation Createresidentcharting($data: ResidentchartingInput!) {
    createResidentcharting(data: $data) { 
        data{     
      attributes {
        daterecordedfrom
        daterecordedto
        notetype
        chartingnote  
	taker
        publishedAt
      }
    }
    }
  }
`;

export const UPDATE_CHARTING = gql`
  mutation UpdateResidentcharting($id: ID!, $data: ResidentchartingInput!) {
    updateResidentcharting(id: $id, data: $data) {
      data {
        id
        attributes {
          daterecordedfrom
          daterecordedto
          notetype
          chartingnote 
	  taker
        }
      }
    }
  }
`;

export const GET_ADLS_BY_RESIDENT = gql`
query GetAdlsByResident($residentId: ID!) {
  residentadls(filters: { resident: { id: { eq: $residentId } } }) {
    data {
      id
      attributes {
        adl
        adltype
        detail          
        startdate
        enddate
        minute
        remind
        status 
        resident {
          data {
            id
            attributes {
              firstname
              lastname
            }
          }
        }
        residentschedules{
          data{
            id
            attributes{   
              time         
              type
              mo
              tu
              we
              th
              fr
              sa
              su
            }
          }
        }
      }
    }
  }
}
`;

export const GET_ADLS = gql`
query{
    residentadls{
      data{
        id
        attributes{            
          adl
          adltype
          detail          
          startdate
          enddate
          minute
          remind
          status
        }
      }
    }
  }
`;

export const CREATE_ADL = gql`
  mutation Createresidentadl($data: ResidentadlInput!) {
    createResidentadl(data: $data) { 
        data{  
          id   
      attributes {
        adl
        adltype
        detail          
        startdate
        enddate
        minute
        remind
        status
        publishedAt
      }
    }
    }
  }
`;
export const UPDATE_ADL = gql`
  mutation Updateresidentadl($id: ID!, $data: ResidentadlInput!) {
    updateResidentadl(id: $id, data: $data) { 
        data{     
          id
      attributes {
        adl
        adltype
        detail          
        startdate
        enddate
        minute
        remind
        status
      }
    }
    }
  }
`;

export const GET_SCHEDULES_BY_ADL = gql`
query GetSchedulesByAdl($adlId: ID!) {
  residentschedules(filters: { adl: { id: { eq: $adlId } } }) {
    data {
      id
      attributes {
        time         
        type
        mo
        tu
        we
        th
        fr
        sa
        su
        residentadl {
          data {
            id
            attributes {
              adl
              adltype
              detail          
              startdate
              enddate
              minute
              remind
              status              
            }
          }
        }
      }
    }
  }
}
`;


export const GET_SCHEDULES = gql`
query{
    residentschedules{
      data{
        id
        attributes{   
          time         
          type
          mo
          tu
          we
          th
          fr
          sa
          su
        }
      }
    }
  }
`;


export const CREATE_SCHEDULE = gql`
  mutation Createresidentschedule($data: ResidentscheduleInput!) {
    createResidentschedule(data: $data) { 
        data{     
      attributes {
        time         
        type
        mo
        tu
        we
        th
        fr
        sa
        su
        publishedAt
      }
    }
    }
  }
`;
export const UPDATE_SCHEDULE = gql`
  mutation Updateresidentschedule($id: ID!, $data: ResidentscheduleInput!) {
    updateResidentschedule(id: $id, data: $data) { 
        data{     
          id
      attributes {
        time         
          type
          mo
          tu
          we
          th
          fr
          sa
          su
      }
    }
    }
  }
`;

export const GET_CAREHOMES = gql`
  query {
    carehomes(sort: "streetname:asc") { 
          documentId  
          streetname
          housenumber
          city
          state
          zipcode
          gps    
	  admin
          users_permissions_users {
          documentId
    }    
    }
  }
`;

export const GET_CAREHOMES_BY_USER = gql`
  query GetCarehomesByUser($userId: ID!) {
    carehomes(filters: {
      users_permissions_users: {
        documentId: { eq: $userId }
      }
    }
    sort: "streetname:asc"  ) {
      documentId
      streetname
      housenumber
      city
      state
      zipcode
      gps  
      admin
          users_permissions_users {
          documentId
    }    
    }
  }
`;


export const CREATE_CAREHOME = gql`
  mutation($data: CarehomeInput!) {
    createCarehome(data: $data) {
      documentId
      streetname
      housenumber
      city
      state
      zipcode
      admin
      gps
      users_permissions_users {
      documentId
    }

    }
  }
`;


export const UPDATE_CAREHOME = gql`
  mutation($id: ID!, $data: CarehomeInput!) {
    updateCarehome(documentId: $id, data: $data) {     
          streetname
          housenumber
          city
          state
          zipcode
          gps       
	  admin
          users_permissions_users {
      documentId
      fullname
    }    
    }
  }
`;

export const GET_CLOCKINOUTS = gql`
  query GetClockInOuts($admin: String) {
    clockinouts(
    sort: "in:desc"
    filters: { users_permissions_user: { admin: { eq: $admin } } }
    ) { 
          documentId  
          in
          out
          locationin
          locationout
          decision
          note
          users_permissions_user {
      documentId
      fullname
      admin
      username
    }    
      carehome{
      documentId
      housenumber
      streetname
      gps
      }
    }
  }
`;

export const UPDATE_CLOCKINOUTDECISION = gql`
  mutation($id: ID!, $data: ClockinoutInput!) {
    updateClockinout(documentId: $id, data: $data) {     
          decision          
    }
  }
`;

export const UPDATE_CLOCKINOUTTIME = gql`
  mutation($id: ID!, $data: ClockinoutInput!) {
    updateClockinout(documentId: $id, data: $data) {
      in
      out
      locationin
      locationout
      decision
    }
  }
`;

export const UPDATE_CLOCKINOUTNOTE = gql`
  mutation($id: ID!, $data: ClockinoutInput!) {
    updateClockinout(documentId: $id, data: $data) {     
          note          
    }
  }
`;

export const GET_PAYROLL_CLOCKINOUTS = gql`
  query GetPayrollClockInOuts(
    $admin: String
    $start: DateTime
    $end: DateTime
  ) {
    clockinouts(
      sort: "in:desc"
      pagination: { limit: 1000 }
      filters: {
        users_permissions_user: {
          admin: { eq: $admin }
        }
        in: {
          gte: $start
          lte: $end
        }
        decision: {
          eq: "approved"
        }
      }
    ) {
      documentId
      in
      out
      decision
      note

      users_permissions_user {
        documentId
        fullname
        username
        email
        admin
        rateperhour
        rateperday
      }

      carehome {
        documentId
        housenumber
        streetname
        gps
      }
    }
  }
`;
